module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAI9JREFUWAntljEKgDAUQ624eDIv4rG8iCdzVP4gZK0+xEC69C8N4f1A05btOAeH42C0PE43TMrwvs6tNGm98Tb69ztG6Q2FaIjSBGi9ZDREaQK0XjIaojQBWs8mo1jBpQmq3quGX02+t8U/fVOmbVYfo5oxYg5RgqJqhKjSIOYQJSiqhg1Rm7+++7/WdXw5X4lBKwcSVMJZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/mixers/QuickSelection-07.png
// module id = 1079
// module chunks = 2